/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React from 'react';
import {Text, View, StyleSheet, Dimensions, ImageBackground} from 'react-native';
import { LinearProgress } from 'react-native-elements';
Dimensions.get('window').width;
Dimensions.get('window').height;
const progressColorDefault = "red";
const textDefault = "Loading...";

const FullScreenImageLoader = (props) => (
  <View style={{flex: 1, justifyContent: 'center', backgroundColor: 'rgba(0,0,0,9)'}}>
   {props.image? (
       <ImageBackground source={props.image} resizeMode="cover" style={styles.image}>
         <LinearProgress color={props.progressColor? (props.progressColor) : (progressColorDefault)}/>
         <Text style={styles.text}>{props.text? (props.text) : (textDefault)}</Text>
         <LinearProgress color={props.progressColor? (props.progressColor) : (progressColorDefault)}/>
       </ImageBackground>
   ) : (
   <>
         <LinearProgress color={props.progressColor? (props.progressColor) : (progressColorDefault)}/>
         <Text style={styles.text}>{props.text? (props.text) : (textDefault)}</Text>
         <LinearProgress color={props.progressColor? (props.progressColor) : (progressColorDefault)}/>
   </>
   )}
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  image: {
    flex: 1,
    justifyContent: "center",
  },
  text: {
    color: "white",
    fontSize: 42,
    lineHeight: 84,
    fontWeight: "bold",
    textAlign: "center",
    backgroundColor: "#000000c0"
  }
});

export default FullScreenImageLoader;